import AppStoreLogo from "../../assets/download-on-the-app-store.svg"
import AndroidAppLogo from "../../assets/download-android-app-logo.png"
import TuberDriverLogo from "../../assets/tuber_driver.webp"

export default function ContactSection() {
    return (
        <section className="py-16 px-4 md:px-8 bg-white">
            <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">
                {/* Contact Form */}
                <div className="md:col-span-2 bg-white shadow-shadow-4 rounded-lg p-5 md:p-8">
                    <h2 className="text-2xl md:text-4xl font-bold text-headings mb-6">Get in Touch</h2>

                    <form className="space-y-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <input
                                type="text"
                                placeholder="Full Name"
                                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                            />
                            <input
                                type="email"
                                placeholder="Email"
                                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                            />
                            <input
                                type="text"
                                placeholder="Phone"
                                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                            />
                            <input
                                type="text"
                                placeholder="Suburb"
                                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                            />
                        </div>
                        <textarea
                            rows="4"
                            placeholder="Message"
                            className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                        ></textarea>
                        <button
                            type="submit"
                            className="w-full bg-primary text-white rounded-md py-3 px-6 font-medium hover:bg-opacity-85 transition duration-300"
                        >
                            Submit
                        </button>
                    </form>
                </div>

                {/* Contact Info */}
                <div className="bg-primary text-white p-5 md:p-8 rounded-lg">
                    <h3 className="text-2xl font-semibold mb-6">Contact Info</h3>

                    <div className="space-y-4 text-lg">
                        {/* Contact Details */}
                        <div>
                            <p className="font-semibold">Call</p>
                            <p className="text-white/90">0418 806 090</p>
                        </div>
                        <div>
                            <p className="font-semibold">Email</p>
                            <p className="text-white/90">contact@tuber.delivery</p>
                        </div>
                        <div>
                            <p className="font-semibold">Business Hours</p>
                            <p className="text-white/90">9:00 AM – 5:00 PM, Monday to Friday</p>
                        </div>

                        {/* App Download Section */}
                        <div>
                            <p className="font-semibold mb-2">Download the Tuber app!</p>
                            <div className="flex flex-col sm:flex-row gap-4">
                                {/* Apple App Store */}
                                <a
                                    href="https://apps.apple.com/au/app/tuber-express-delivery/id1567203793?platform=iphone"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={AppStoreLogo} alt="app-store-logo" loading="lazy" className="h-11" />
                                </a>

                                {/* Google Play Store */}
                                <a
                                    href="https://play.google.com/store/apps/details?id=com.tuber.user&hl=en_AU"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src={AndroidAppLogo} alt="android-app-logo" loading="lazy" className="h-11" />
                                </a>
                            </div>
                        </div>

                        {/* Driver App */}
                        <div>
                            <p className="font-semibold">For Drivers</p>
                            <a
                                href="https://apps.apple.com/au/app/tuber-driver/id1567211555"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center gap-2 mt-2"
                            >
                               <img src={TuberDriverLogo} alt="" className="h-9 object-cover rounded-md" /> Download Driver App
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
}
